import { useState } from 'react';

// Marca da aplicação.
//
// O logo era carregado de `static.readdy.ai` em seis telas — a identidade do
// produto dependia de um serviço do qual estamos saindo, e uma indisponibilidade
// lá deixaria o cabeçalho vazio aqui. Agora é arquivo local, e este componente é
// o único lugar que sabe o caminho.
//
// Enquanto o arquivo não existir em `portal/public/`, cai na marca textual: um
// logo quebrado é pior que uma marca simples, e a tela não deve depender de
// alguém lembrar de subir a imagem.

const ARQUIVO = '/logo-central-check.png';

interface Props {
  /** Classes de tamanho e ajuste, iguais às que o `<img>` recebia. */
  className?: string;
  /** Marca textual usa a cor do texto do container; útil sobre fundo colorido. */
  monocromatico?: boolean;
}

export default function Logo({ className = 'w-8 h-8 object-contain', monocromatico }: Props) {
  const [semArquivo, setSemArquivo] = useState(false);

  if (semArquivo) {
    return (
      <span
        role="img"
        aria-label="Central Check"
        className={`${className} inline-flex items-center justify-center rounded-lg font-bold leading-none ${
          monocromatico ? 'border border-current' : 'bg-primary-500 text-background-50'
        }`}
      >
        CC
      </span>
    );
  }

  return (
    <img
      src={ARQUIVO}
      alt="Central Check"
      // Sobre fundo colorido — o círculo do login e do cadastro — o logo é
      // achatado para branco. Sem isto ele aparece colorido dentro do círculo
      // azul, que é onde a versão anterior usava `brightness-0 invert`.
      className={`${className}${monocromatico ? ' brightness-0 invert' : ''}`}
      onError={() => setSemArquivo(true)}
    />
  );
}
